package com.eladfinish.bible.contest.features.copyOptions

import androidx.compose.runtime.Immutable
import com.eladfinish.bible.contest.screens.search.ui.HighlightType

@Immutable
data class CopyOptions(
    val withNikud: Boolean,
    val withTeamim: Boolean,
    val hideGodNames: Boolean,
    val includeBookAndChapter: Boolean,
    val sortResults: Boolean = false,
    val removeVerseOrigin: Boolean = false,
    val removeDuplicates: Boolean = false,
    val includeExpression: Boolean = true,
    val copyOnlyHighlights: Boolean = false,
    val highlightType: HighlightType = HighlightType.BRACKETS,
)
